const trimText = (value) => String(value ?? "").trim();

export const resolveContractEmailRecipient = (contract = {}) => {
  const personEmail = trimText(contract.person_email_primary ?? contract.personEmailPrimary);
  if (personEmail) {
    return {
      email: personEmail,
      name: trimText(contract.person_name ?? contract.personName),
    };
  }

  const companyEmail = trimText(contract.company_email_primary ?? contract.companyEmailPrimary);
  if (companyEmail) {
    return {
      email: companyEmail,
      name: trimText(contract.company_name ?? contract.companyName),
    };
  }

  return {
    email: "",
    name: trimText(contract.person_name ?? contract.personName ?? contract.company_name ?? contract.companyName),
  };
};
